import { makeEntityScaffold } from '@classpass/saga-tools';
export var dashFeatureById = makeEntityScaffold('SAGA.API.DASH_FEATURE_BY_ID', function (client, id) {
  return client.dash.getFeatureFlag(id);
}, {
  defaultKey: 1
});